import React from 'react';
import { Colors } from 'library';

interface RUserCheckProps {
    size?: number;
    color?: string;
}

export function RUserCheck({ size = 16, color = Colors.turquoise }: RUserCheckProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
            <circle cx="8" cy="8" r="8" fill={color} />
            <path d="M5 8l2 2 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
